import QueryBoundary from "../../components/ui/QueryBoundary";
import useApiQuery from "../../hooks/useApiQuery";
import endpoints from "../../api/endpoints";
import { formatJalali } from "../../lib/jalali";

const COLUMNS = [
  "تاریخ خرید",
  "مبلغ خرید",
  "شناسه پرداخت",
  "شروع اشتراک",
  "پایان اشتراک",
  "وضعیت پرداخت",
];

const PaymentsTab = () => {
  const query = useApiQuery(endpoints.paymentList(), {
    select: (data) => data.payments ?? [],
  });

  return (
    <QueryBoundary
      {...query}
      isEmpty={(payments) => payments.length === 0}
      emptyMessage="هیچ پرداختی برای نمایش وجود ندارد"
    >
      {(payments) => (
        <div className="relative overflow-x-auto pl-8">
          <table className="w-full text-left text-sm text-gray-400 rtl:text-right">
            <thead className="bg-[#5B5B5B] text-xs uppercase text-white">
              <tr>
                {COLUMNS.map((column) => (
                  <th key={column} scope="col" className="px-6 py-3">
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {payments.map((payment) => (
                <tr
                  key={payment.id}
                  className="border-b border-gray-700 bg-[#333333]"
                >
                  <th
                    scope="row"
                    className="whitespace-nowrap px-6 py-4 font-medium text-white"
                  >
                    {formatJalali(payment.datetime)}
                  </th>
                  <td className="px-6 py-4">
                    {payment.amount?.toLocaleString()} تومان
                  </td>
                  <td className="px-6 py-4">
                    {payment.payment_code || "------------"}
                  </td>
                  <td className="px-6 py-4">
                    {formatJalali(payment.start_date)}
                  </td>
                  <td className="px-6 py-4">
                    {formatJalali(payment.end_date)}
                  </td>
                  <td className="px-6 py-4">
                    {payment.verified ? "موفق" : "ناموفق"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </QueryBoundary>
  );
};

export default PaymentsTab;
